/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddStandardTaskGroupsToProjectDto } from '../models/work-add-standard-task-groups-to-project-dto';
import { WorkStandardtaskgroup } from '../models/work-standardtaskgroup';

@Injectable({ providedIn: 'root' })
export class WorkStandardtaskgroupsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `standardtaskgroupsV2ControllerGetAllByContainerTypeId()` */
  static readonly StandardtaskgroupsV2ControllerGetAllByContainerTypeIdPath = '/v2/standardtaskgroups/byContainertypeId/{containertypeId}';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtaskgroupsV2ControllerGetAllByContainerTypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtaskgroupsV2ControllerGetAllByContainerTypeId$Response(
    params: {
      containertypeId: number;
      idsToExclude?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkStandardtaskgroup>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtaskgroupsV2Service.StandardtaskgroupsV2ControllerGetAllByContainerTypeIdPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
      rb.query('idsToExclude', params.idsToExclude, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkStandardtaskgroup>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtaskgroupsV2ControllerGetAllByContainerTypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtaskgroupsV2ControllerGetAllByContainerTypeId(
    params: {
      containertypeId: number;
      idsToExclude?: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<WorkStandardtaskgroup>> {
    return this.standardtaskgroupsV2ControllerGetAllByContainerTypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkStandardtaskgroup>>): Array<WorkStandardtaskgroup> => r.body)
    );
  }

  /** Path part for operation `standardtaskgroupsV2ControllerAddStandardtaskgroupsToProject()` */
  static readonly StandardtaskgroupsV2ControllerAddStandardtaskgroupsToProjectPath = '/v2/standardtaskgroups/addStandardtaskgroupsToProject';

  /**
   * Required permissions: tasks:create, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtaskgroupsV2ControllerAddStandardtaskgroupsToProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardtaskgroupsV2ControllerAddStandardtaskgroupsToProject$Response(
    params: {
      body: WorkAddStandardTaskGroupsToProjectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtaskgroupsV2Service.StandardtaskgroupsV2ControllerAddStandardtaskgroupsToProjectPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: tasks:create, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtaskgroupsV2ControllerAddStandardtaskgroupsToProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardtaskgroupsV2ControllerAddStandardtaskgroupsToProject(
    params: {
      body: WorkAddStandardTaskGroupsToProjectDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.standardtaskgroupsV2ControllerAddStandardtaskgroupsToProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
